import { useState } from "react";
import { Trash2, Lock, Loader2, Undo2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

const ico = "inline-flex h-8 items-center justify-center gap-1 rounded-full border px-2.5 text-[11px] font-bold uppercase tracking-widest transition-colors";

// Torri elimina definitivamente; il Partner nasconde la pratica solo dalla sua vista (non se firmata o con caparra)
export function CfgDelete({ c, torri, reload, protetta }) {
  const [ask, setAsk] = useState(false);
  const [busy, setBusy] = useState(false);
  const run = async (fn, ok) => {
    setBusy(true);
    try { await fn(); toast.success(ok); reload(); } catch (e) { toast.error(e.response?.data?.detail || "Operazione non riuscita"); }
    setBusy(false); setAsk(false);
  };
  if (!torri && protetta) return <span className={`${ico} border-neutral-800 text-neutral-600`} title="Consulenza firmata o con caparra: non si può eliminare" data-testid={`vesta-cfg-lock-${c.id}`}><Lock className="h-3.5 w-3.5" /></span>;
  const del = () => run(() => (torri ? api.delete(`/rete/configs/${c.id}`) : api.post(`/vesta/pratiche/${c.id}/nascondi`)), torri ? "Configurazione eliminata definitivamente" : "Configurazione eliminata dalla tua lista");
  return (
    <>
      {torri && c.nascosta_partner && <button type="button" disabled={busy} onClick={() => run(() => api.post(`/rete/configs/${c.id}/ripristina`), "Configurazione restituita al partner")}
        className={`${ico} border-neutral-700 text-neutral-200 hover:border-[#C17F59] hover:text-[#C17F59]`} title="Rendi di nuovo visibile al partner" data-testid={`vesta-cfg-ripristina-${c.id}`}><Undo2 className="h-3.5 w-3.5" /></button>}
      {ask ? (
        <button type="button" disabled={busy} onClick={del} onBlur={() => !busy && setAsk(false)} autoFocus data-testid={`vesta-cfg-delete-confirm-${c.id}`}
          className={`${ico} border-red-700 bg-red-600 text-white`}>{busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Trash2 className="h-3.5 w-3.5" />}{torri ? "Elimina per sempre" : "Conferma"}</button>
      ) : (
        <button type="button" onClick={() => setAsk(true)} title={torri ? "Elimina definitivamente" : "Elimina dalla tua lista"} data-testid={`vesta-cfg-delete-${c.id}`}
          className={`${ico} border-neutral-700 text-neutral-400 hover:border-red-700 hover:text-red-400`}><Trash2 className="h-3.5 w-3.5" /></button>
      )}
    </>
  );
}
